import { forEach } from '@angular-devkit/schematics';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import * as moment from 'moment';
import { AuthService } from 'src/app/core/authentication/services/auth.service';
import { DateHelperService } from 'src/app/core/helpers/date-helper/date-helper.service';
import { FormHelperService } from 'src/app/core/helpers/form-helper/form-helper.service';
import { AppointmentWorkforceForm } from 'src/app/core/models/appointment-workforce-form.model';
import { Appointment } from 'src/app/core/models/appointment.model';
import { ConfigSetting } from 'src/app/core/models/config-settings.model';
import { FieldEntry, ListValue, WorkforceForm, WorkforceFormEntry } from 'src/app/core/models/workforce-form.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';
import { UserService } from 'src/app/core/services/user/user-service';
import { TimeEntryService } from 'src/app/core/time-entry/time-entry.service';
import { LocalStorageService } from 'src/app/core/storage/local-storage/local-storage.service';
import { LocalStorage } from 'src/app/core/storage/local-storage/local-storage';
import { SignaturePad } from 'angular2-signaturepad';
import { Console } from 'console';

@Component({
     selector: 'app-workforce-form',
     templateUrl: './workforce-form.component.html',
     styleUrls: ['./workforce-form.component.scss']
})
export class WorkforceFormComponent implements OnInit {

     @Input()
     mode = 'Add'; // Add || Edit

     @Input()
     workforceForm: WorkforceFormEntry = new WorkforceFormEntry();

     @Input()
     apptWorkforceForm: AppointmentWorkforceForm;

     @Input()
     hidden = [] as string[];

     @Input()
     DisableEditOnCleared: ConfigSetting;

     pageTitle = 'Form';

     formGroup: FormGroup;

     editForm: WorkforceForm;

     // Dropdown options
     appointmentOptions: Appointment[];

     // Defaults
     appointmentOptionDefault = new Appointment({ id: -2000, displayValue: 'Other' });

     dateTimeTypes = ['DateTime', 'Calendar'];
     textAreaTypes = ['TextBox', 'Comment'];
     selectTypes = ['ComboBox', 'ComboBoxCheckBox'];
     textBlockTypes = ['TextBlock'];
     store: LocalStorage;
     workforceForms: WorkforceForm[];
     addableWorkforceForms: WorkforceForm[];

     signaturePadOptions: Object = {
          'canvasWidth': 1000,
          'canvasHeight': 150
     };

     @ViewChild(SignaturePad) signaturePad: SignaturePad;

     constructor(
          private modalController: ModalController,
          private formBuilder: FormBuilder,
          public formHelper: FormHelperService,
          private appointmentService: AppointmentService,
          public dateHelper: DateHelperService,
          private toastController: ToastController,
          private storage: LocalStorageService,
     ) { }

     isHidden(inputName: string): boolean {
          return this.hidden.includes(inputName);
     }

     async ngOnInit(): Promise<void> {
          await this.setOptions();
          this.setForm();
     }

     async setForm(): Promise<void> {
          //console.warn('setForm enter');
          this.formGroup = await this.formBuilder.group({
               appointment: [await this.initAppointmentField()],
          });

          //console.warn('setForm exit');


          //console.table(this.workforceForm?.entries);
          //this.workforceForm?.entries?.forEach(e => {
          //     if (e.fieldTypeDescription == 'CheckBox') {
          //          this.formGroup.addControl(e.id.toString(), new FormControl(e.value == '1', Validators.required));
          //     }
          //     else if (this.textAreaTypes.includes(e.fieldTypeDescription) || e.fieldTypeDescription == 'Signature') {
          //          this.formGroup.addControl(e.id.toString(), new FormControl(e.value));
          //     }
          //     else if (e.fieldTypeDescription == 'ComboBoxCheckBox' && e.value?.length > 0) {
          //          try {
          //               e.value = JSON.parse(e.value);
          //          }
          //          catch (ex) {
          //               console.warn('Unable to JSON.parse ComboBoxCheckBox value: ', e.value);
          //          }
          //          this.formGroup.addControl(e.id.toString(), new FormControl(e.value));
          //     }
          //     //else if (this.dateTimeTypes.includes(e.fieldTypeDescription)) {
          //     //	this.formGroup.addControl(e.id.toString(), new FormControl(new Date(e.value)));
          //     //}
          //     else if (e.fieldTypeDescription == 'Calendar' && e.value.length > 10) {
          //          e.value = e.value.substring(0, 10);
          //          this.formGroup.addControl(e.id.toString(), new FormControl(e.value, Validators.required));
          //     }
          //     else {
          //          this.formGroup.addControl(e.id.toString(), new FormControl(e.value, Validators.required));
          //     }
          //});

          //if (this.mode === 'Edit') {
          //     this.formGroup.controls.appointment.disable();
          //}

          if (this.mode === 'Edit') {

               this.formGroup.controls.appointment.disable();

               this.workforceForm?.entries?.forEach(e => {
                    if (e.fieldTypeDescription == 'ComboBoxCheckBox') {

                         try {
                              e.value = JSON.parse(e.value);
                              this.formGroup.addControl(e.id.toString(), new FormControl(e.value));
                         }
                         catch (ex) {
                              console.warn('Unable to JSON.parse ComboBoxCheckBox value: ', e.value);
                         }
                    }
                    else if (e.fieldTypeDescription == 'Signature') {
                         console.log('Signature');
                         console.log(e.value);

                         //this.formGroup.addControl(e.id.toString(), new FormControl(''));
                         this.signaturePad.fromDataURL(e.value);
                    }
                    else {
                         this.formGroup.addControl(e.id.toString(), new FormControl(e.value));
                    }
               });
          }
          else {
               this.workforceForm?.entries?.forEach(e => {
                    if (e.fieldTypeDescription == 'ComboBoxCheckBox' || e.fieldTypeDescription == 'ComboBox') {

                         this.formGroup.addControl(e.id.toString(), new FormControl('', Validators.required));
                    }
                    else {
                         this.formGroup.addControl(e.id.toString(), new FormControl(''));
                    }
               });
          }
     }

     async initAppointmentField(): Promise<Appointment> {
          if (this.apptWorkforceForm == null || this.apptWorkforceForm.apptId === -2000) {
               return this.appointmentOptionDefault;
          }

          return await this.appointmentService.getLocalAppointment(this.apptWorkforceForm.apptId);
     }

     async setOptions(): Promise<void> {
          await Promise.all([
               this.setAppointmentOptions()
          ]);

          const appt = await this.initAppointmentField();
          this.store = this.storage['forms'];
          this.workforceForms = await this.store.getAll();
          const formIds = appt.forms.map(f => f.id);
          //this.workforceForms = this.workforceForms.filter(f => !formIds.includes(f.id));

          this.addableWorkforceForms = this.workforceForms.filter(f => !formIds.includes(f.id)).filter(f => f.availabeTicketCodes.includes(appt.ticketCodeId));

     }

     checkUsed(workforceForm: WorkforceForm): boolean {
          return workforceForm.id != this.workforceForm.id;
     }

     async setAppointmentOptions(): Promise<void> {
          let appts = await this.appointmentService.getAllAppointments();
          appts.sort((b, a) => new Date(b.apptStart).getTime() - new Date(a.apptStart).getTime());

          if (this.mode === 'Add') {
               if (this.DisableEditOnCleared?.value === 'True') {
                    appts = appts.filter(appt => !appt.ticketStatusIsEndStatus);
               }
          }

          this.appointmentOptions = appts;
     }

     async onClickWorkforceForm(): Promise<void> {
          this.formGroup = this.formHelper.markAsTouched(this.formGroup);
          if (this.formGroup.invalid) {
               await this.formHelper.alertUser({ header: this.mode + ' Workforce Form Failed' });
               return;
          }
          for (let i = 0; i < this.workforceForm.entries.length; i++) {

               if (this.workforceForm.entries[i].fieldTypeDescription == 'Signature' && (this.signaturePad.isEmpty() || this.signaturePad == null)) {

                    await this.formHelper.alertUser({ header: this.mode + ' Workforce Form Failed' });
                    return;
               }

               if (this.workforceForm.entries[i].fieldTypeDescription == 'Signature' && !this.signaturePad.isEmpty()) {
                    console.log(this.signaturePad.toDataURL());
                    this.workforceForm.entries[i].value = this.signaturePad.toDataURL();
               }
               else if (this.workforceForm.entries[i].fieldTypeDescription == 'CheckBox') {
                    this.workforceForm.entries[i].value = this.formGroup.controls[this.workforceForm.entries[i].id].value ? '1' : '0';
               }
               else if (this.workforceForm.entries[i].fieldTypeDescription == 'ComboBoxCheckBox' && Array.isArray(this.formGroup.controls[this.workforceForm.entries[i].id]?.value)) {
                    this.workforceForm.entries[i].value = JSON.stringify(this.formGroup.controls[this.workforceForm.entries[i].id].value);
               }
               else if (this.workforceForm.entries[i].fieldTypeDescription == 'TextBlock') {
                    this.workforceForm.entries[i].value = this.workforceForm.entries[i].value;
               }
               else {

                    this.workforceForm.entries[i].value = this.formGroup.controls[this.workforceForm.entries[i].id].value ?? '';
               }
          }

          //await this.appointmentService.addWorkforceForm(this.apptWorkforceForm.apptId, this.workforceForm);

          if (this.mode === 'Add') {
               await this.appointmentService.addWorkforceForm(this.apptWorkforceForm.apptId, this.workforceForm);
          }
          else if (this.mode === 'Edit') {
               await this.appointmentService.updateWorkforceForm(this.apptWorkforceForm.apptId, this.workforceForm);
          }
          this.resolveRequest();
     }

     resolveRequest() {
          this.toastWorkforceFormSaved();
          this.dismiss();
     }

     private async toastWorkforceFormSaved(): Promise<void> {
          const toast = await this.toastController.create({
               message: `Form saved.`,
               duration: 3000,
               position: 'top',
               color: 'success',
               buttons: ['Dismiss'],
          });

          await toast.present();
     }

     async dismiss(): Promise<void> {
          await this.modalController.dismiss({
               dismissed: true,
          });
     }

     async onChangeWorkforceForm(value: WorkforceForm): Promise<void> {
          //console.table(value);
          if (!value) {
               return;
          }
          this.workforceForm = new WorkforceFormEntry();
          this.workforceForm.id = value.id;
          this.workforceForm.apptId = this.apptWorkforceForm.apptId;
          this.workforceForm.formName = value.formName;
          this.workforceForm.requiredInMobiletech = value.requiredInMobiletech;
          this.workforceForm.requiredInWorkforce = value.requiredInWorkforce;
          this.workforceForm.requiredToClear = value.requiredToClear;
          this.workforceForm.entries = [];

          value.fields.sort(f => f.defaultFieldOrder).forEach(f => {
               let fieldEntry = new FieldEntry();
               fieldEntry.id = f.id;  //  needs to be unique
               fieldEntry.formFieldId = f.id;
               fieldEntry.displayValue = f.fieldType.displayValue;
               fieldEntry.fieldOrder = f.defaultFieldOrder;
               fieldEntry.fieldTypeDescription = f.fieldType.formTypeDescription;
               if (this.dateTimeTypes.includes(fieldEntry.fieldTypeDescription)) {
                    fieldEntry.value = moment().format().substring(0, 19);
                    if (fieldEntry.fieldTypeDescription === 'Calendar') {
                         fieldEntry.value = fieldEntry.value.substring(0, 10);
                    }
               }
               else if (fieldEntry.fieldTypeDescription === 'Signature') {
                    fieldEntry.value = '';
               }
               else if (fieldEntry.fieldTypeDescription === 'TextBlock') {
                    fieldEntry.value = f.listValues[0].listValue;
               }
               this.workforceForm.entries.push(fieldEntry);

          });

          await this.setForm();

     }

}
